import { Component } from '@angular/core';

// This is a standalone component that is used when the guided-flow's child route is invoked
@Component({
  standalone: true,
  template: "",
})
export class GuidedFlowEmptyComponent {}
